import { IApiService } from '../../../services/ApiService';
import { LoaderFunctionArgs } from 'react-router';
import { handleLoaderError } from '../../../services/loaderErrorHandler';
import { Logger } from '../../../utils/Logger';

export function loglementsPageLoader(apiService: IApiService) {
  return async ({ params, request }: LoaderFunctionArgs) => {
    Logger.debug('LOADER', "logements loader starting with params:", params);
    try {
      if (!params.bailleurId) {
        throw new Error("Invalid id");
      }
      const bailleurId = parseInt(params.bailleurId, 10);
      if (Number.isNaN(bailleurId)) {
        throw new Error("Invalid id");
      }
      const programme = params.programme ?? null;
      const logements = await apiService.getLogements(bailleurId, programme || undefined, request.signal);
      Logger.debug('LOADER', "logements loader completed with", logements.length, "logements");
      return { programme, logements };
    } catch (error) {
      return handleLoaderError(error, request.url);
    }
  };
}
